import { Company } from 'models/entities/company';
import { RelationshipCollection } from 'models/entities/relationship';

type Data = {
  target: Company;
};

type DataToChange = {
  name?: string;
};

class Model {

  readonly target: Company;
  readonly isNew: boolean;
  readonly canDelete: boolean;

  readonly name: string;

  readonly result?: Company;

  constructor(data: Data) {
    this.target = data.target;
    this.isNew = !data.target.id;
    this.canDelete = false;
    this.name = this.target.name;
  }

  async readRelationships(companyId: string): Promise<this> {
    const relationships = await RelationshipCollection.readParentAndOwner(companyId, 1);
    const canDelete = !relationships.exist();
    return Object.assign(Object.create(this.constructor.prototype), { ...this, canDelete });
  }

  change(data: DataToChange): this {
    const props = { ...this, ...data };
    const result = this.validate(props) ? this.build(props) : undefined;
    return Object.assign(Object.create(this.constructor.prototype), { ...props, result });
  }

  private validate(data: DataToChange): boolean {
    if (!data.name) return false;
    return true;
  }

  private build(data: DataToChange): Company {
    const name = data.name;
    return this.target.edit({ name });
  }

  async save(): Promise<this> {
    if (!this.result) throw new Error('invalid result');
    const result = await this.result.save();
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result });
  }

  async delete(): Promise<this> {
    const result = await this.target.delete();
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result });
  }

}

export { Model };